import { Dispatch, Middleware, MiddlewareAPI } from 'redux'
import { MESSAGE_TYPES } from 'types'
import {
  REQUEST_CARRIER_APPROVAL_ACTION_TYPES,
  CARRIER_CREATE_VENDOR_ACTION_TYPES,
  CARRIER_UPDATE_VENDOR_ACTION_TYPES,
  CARRIER_CHECKLIST_UPDATE_ACTION_TYPES,
} from 'utils/actions/carrier'
import { showMessage } from 'utils/actions/globalMessaging'
import { IStore } from '../reducers'

const {
  CARRIER_CREATE_VENDOR_FAILURE,
  CARRIER_CREATE_VENDOR_SUCCESS,
} = CARRIER_CREATE_VENDOR_ACTION_TYPES

const { EDIT_CHECKLIST_FAILURE } = CARRIER_CHECKLIST_UPDATE_ACTION_TYPES

const {
  CARRIER_UPDATE_VENDOR_FAILURE,
  CARRIER_UPDATE_VENDOR_SUCCESS,
} = CARRIER_UPDATE_VENDOR_ACTION_TYPES

export const carrier: Middleware = (store: MiddlewareAPI<Dispatch, IStore>) => (
  next: Dispatch
) => async action => {
  if (action.type === REQUEST_CARRIER_APPROVAL_ACTION_TYPES.REQUEST_CARRIER_APPROVAL_FAILURE) {
    const { error } = action
    const { id } = action.payload.requestData
    const { dotNumber, legalName, mcNumber } = store.getState().carrier.carrierDetails || {}

    let errorParams = {}
    if (error === 'Please add at least one dispatcher or owner-operator.') {
      errorParams = {
        typeLabel: 'Something is missing.',
        cta: {
          label: 'Add User',
          url: `${__ROOT__}/users/new/?orgType=carrier&orgId=${id}&orgName=${legalName}&orgMcNumber=${mcNumber}&orgDotNumber=${dotNumber}`,
        },
      }
    }
    store.dispatch(showMessage(error, { ...errorParams, type: MESSAGE_TYPES.alert }))
  }

  if (action.type === REQUEST_CARRIER_APPROVAL_ACTION_TYPES.REQUEST_CARRIER_APPROVAL_SUCCESS) {
    store.dispatch(
      showMessage('Approval request sent! The carrier and Compliance have been notified.', {
        type: MESSAGE_TYPES.info,
      })
    )
  }

  if ([CARRIER_CREATE_VENDOR_FAILURE, CARRIER_UPDATE_VENDOR_FAILURE].includes(action.type)) {
    store.dispatch(showMessage(action.error, { type: MESSAGE_TYPES.alert }))
  }
  if (action.type === CARRIER_CREATE_VENDOR_SUCCESS) {
    store.dispatch(showMessage('Created Vendor in NetSuite.', { type: MESSAGE_TYPES.info }))
  }
  if (action.type === CARRIER_UPDATE_VENDOR_SUCCESS) {
    store.dispatch(showMessage('Updated Vendor in NetSuite.', { type: MESSAGE_TYPES.info }))
  }
  if (action.type === EDIT_CHECKLIST_FAILURE) {
    store.dispatch(showMessage(`Checklist ${action.error}`, { type: MESSAGE_TYPES.alert }))
  }

  return next(action)
}
